import { Action } from "@ngrx/store"
import { Profile } from "../models/profile"

export const LOAD_ALL = '[Profiles] LoadAll';
export const LOAD_ALL_COMPLETE = '[Profiles] LoadAll Complete';
export const LOAD_ALL_ERROR = '[Profiles] LoadAll Error';

export class LoadAll implements Action {
  readonly type = LOAD_ALL;
  constructor(public product: string) { }
}

export class LoadAllComplete implements Action {
  readonly type = LOAD_ALL_COMPLETE;
  constructor(public payload: Array<Profile>) { }
}

export class LoadAllError implements Action {
  readonly type = LOAD_ALL_ERROR;
  constructor(public payload: any) { }
}

export type Actions =
  LoadAll |
  LoadAllComplete |
  LoadAllError;

